// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__DCRyK","file":"styles_file__1e5xB"};